module.exports = __webpack_public_path__ + "img/users.682d6772.svg";